// import { Auth } from 'aws-amplify'
import React from 'react'
import { Button, Modal } from 'react-bootstrap'
// import AwsConfig from '../../Config/AwsConfig'
// import GetUserPermissions from '../../Services/Queries/GetUserPermissions'
// import { DefinedPermissions } from '../Constants/Permissions'
// import AllTaggedPersonsView from './AllTaggedPersonsView'
import DisplayNameInFooter from './DisplayNameInFooter'
import MoviePersonAutoSuggestions from './MoviePersonAutoSuggestions'
import SelectedMoviesPersonData from './SelectedMoviesPersonData'
import SubmitButton from './SubmitButton'
//
export default function TaggedPersonsUI(props) {
  const {
    allTaggedPersons,
    // removePersonFromTaggedPersons,
    searchBarVisible,
    toggleSearchBar,
    createListValidation,
    listData,
    selectedListType,
    searchMoviePerson,
    autoSuggestions,
    handleSelectAutoSuggestion,
    selectedMovieOrPersonData,
    handleDelete,
    movieAlreadyAdded,
    editIndexes,
    handleChangeDescription,
    handleMoveItem,
    handleEdit,
    sendTaggedPersons,
    // addOrRemoveTaggedPerson,
    editMode,
    SubmitCreateList,
    setSelectedMovieOrPersonData,
    imagePreview,
    valueEdited,
    setvalueEdited,
  } = props
  // const [valueEdited, setvalueEdited] = useState(false)
  const valueAdded = () => {
    toggleSearchBar()
    setvalueEdited(true)
  }

  return (
    <>
      <div className='mt-4'>
        <button
          type='button'
          className='btn btn-primary'
          onClick={() => toggleSearchBar()}
          disabled={createListValidation()}
        >
          Add {selectedListType}
        </button>

        {/* {!searchBarVisible && selectedListType === 'Movie' && (
          <AllTaggedPersonsView
            allTaggedPersons={allTaggedPersons}
            removePersonFromTaggedPersons={removePersonFromTaggedPersons}
          />
        )} */}
        <Modal show={searchBarVisible} onHide={() => toggleSearchBar()}>
          <Modal.Body>
            <input
              className='form-control'
              placeholder={`search ${selectedListType}`}
              onChange={event => searchMoviePerson(event.target.value)}
            />
            <MoviePersonAutoSuggestions
              autoSuggestions={autoSuggestions}
              searchBarVisible={searchBarVisible}
              handleSelectAutoSuggestion={handleSelectAutoSuggestion}
            />
          </Modal.Body>
          <Modal.Footer>
            <DisplayNameInFooter
              selectedListType={selectedListType}
              selectedMovieOrPersonData={selectedMovieOrPersonData}
              handleDelete={handleDelete}
              movieAlreadyAdded={movieAlreadyAdded}
            />
            {/* disable ok button if no movie or person is selected */}
            <Button disabled={selectedMovieOrPersonData.length <= 0} onClick={valueAdded}>
              Ok
            </Button>
          </Modal.Footer>
        </Modal>
        {!searchBarVisible && (
          <SelectedMoviesPersonData
            selectedMovieOrPersonData={selectedMovieOrPersonData}
            editIndexes={editIndexes}
            handleChangeDescription={handleChangeDescription}
            handleDelete={handleDelete}
            handleMoveItem={handleMoveItem}
            handleEdit={handleEdit}
            allTaggedPersons={allTaggedPersons}
            selectedListType={selectedListType}
            sendTaggedPersons={sendTaggedPersons}
            // addOrRemoveTaggedPerson={addOrRemoveTaggedPerson}
            editMode={editMode}
            setSelectedMovieOrPersonData={setSelectedMovieOrPersonData}
            setvalueEdited={setvalueEdited}
          />
        )}
        <SubmitButton
          SubmitCreateList={SubmitCreateList}
          sendLoadSpinner={props.sendLoadSpinner}
          listData={listData}
          createListValidation={createListValidation}
          editMode={editMode}
          imagePreview={imagePreview}
          selectedMovieOrPersonData={selectedMovieOrPersonData}
          valueEdited={valueEdited}
        />
      </div>
    </>
  )
}
